(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-animation"] && !window.DesignMode) return;
  try {
    
  const options = {
    marginTop: window.innerWidth < 750 ? 40 : 50,
    duration: 500,
    delay: 2000,
  };

  const countFrames = document.querySelectorAll('.hero-animation__wrapper div').length;

  let animation;

  const createFrame = (order) => {
    const marginTop = -1 * options.marginTop * order;
    return {
      targets: `.hero-animation__wrapper div:first-child`,
      marginTop,
      easing: 'linear',
      duration: options.duration,
      delay: options.delay,
    };
  };

  function createAnimation() {
    const timeline = anime.timeline({
      loop: false,
      complete: function (anim) {
        const wrapper = document.querySelector('.hero-animation__wrapper');
        wrapper.classList.add('hero-animation__wrapper--expanded');
      },
    });

    for (let i = 1; i <= countFrames; i++) {
      timeline.add(createFrame(i));
    }

    return timeline;
  }

  if (countFrames > 1) {
    animation = createAnimation();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-count-animation"] && !window.DesignMode) return;
  try {
    
  const count = document.querySelector('.count-animation__count');
  const countAnimation = anime({
    targets: count,
    innerHTML: [0, 100],
    easing: 'linear',
    round: 1,
    duration: 7500,
    begin: () => {
      count.style.width = '11rem';
    },
    update: (anim) => {
      if (Math.round(anim.progress) > 98) {
        count.style.width = 'auto';
      }
    },
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        countAnimation.play();
      } else {
        countAnimation.pause();
      }
    });
  });

  observer.observe(count);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-text-banner"]) return;
  try {
    
  const options = {
    opacityIn: [0, 1],
    translateYIn: [30, 0],
    translateYOut: [0, -30],
    durationIn: 500,
    durationOut: 300,
    delay: 3000,
  };

  const countFrames = document.querySelectorAll('.hs-text-banner p').length;

  let animation;

  const createInOutFrames = (order) => {
    return [
      {
        targets: `.hs-text-banner p:nth-child(${order})`,
        opacity: options.opacityIn,
        translateY: options.translateYIn,
        easing: 'linear',
        duration: options.durationIn,
      },
      {
        targets: `.hs-text-banner p:nth-child(${order})`,
        opacity: 0,
        translateY: options.translateYOut,
        duration: options.durationOut,
        easing: 'linear',
        delay: options.delay,
      },
    ];
  };

  function createAnimation() {
    const timeline = anime.timeline({ loop: true });

    for (let i = 1; i <= countFrames; i++) {
      // prettier-ignore
      timeline
      .add(createInOutFrames(i)[0])
      .add(createInOutFrames(i)[1]);
    }

    return timeline;
  }

  if (countFrames > 1) {
    animation = createAnimation();
  } else {
    stopAnimation();
  }

  function startAnimation() {
    if (animation) {
      animation.play();
    }
    document.querySelectorAll('.hs-text-banner p').forEach((p) => {
      p.style.opacity = 0;
      p.style.transform = 'scale(0)';
    });
  }

  function stopAnimation() {
    if (animation) {
      animation.pause();
    }
    document.querySelectorAll('.hs-text-banner p').forEach((p) => {
      p.style.opacity = 1;
      p.style.transform = 'scale(1)';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
let ajaxinateInitialized = false;

document.addEventListener('DOMContentLoaded', function () {
  if (!ajaxinateInitialized) {
    new Ajaxinate({
      container: '#product-grid',
      pagination: '.infinite_next',
      loadingText: 'Loading...',
      callback: function () {
        const event = new Event('DOMContentLoaded');
        document.dispatchEvent(event);
      }
    });

  ajaxinateInitialized = true;
  }
});

  } catch(e) { console.error(e); }
})();
      })();
